import { gql } from "@apollo/client";

export const UPDATE_DRIVER_PROFILE = gql`
  mutation updateDriverProfile(
    $driverProfileId: String!,
    $driverUserInput: UpdateDriverUserInput!
  ) {
    updateDriverProfile(
      driverProfileId: $driverProfileId,
      driverUserInput: $driverUserInput
    ) {
        id
        firstName
        lastName
        email
        phoneNumber {
          phone
          country
        }
        dateOfBirth
        license {
          licenseNumber
          dateOfExpiry
          dateOfIssue
          issuingAuthority
          endorsement
          frontImage
          backImage
          offences
          points
          dvlaVerificationStatus
        }
        nationalInsuranceNumber
        documents {
          id
          documentKey
          title
          documentName
          expiryDate
          documentType
          reminderBefore
          createdAt
        }
        profilePicture
        address {
          street
          city
          fullAddress
          state
          country
          zipcode
        }
      }
  }
`;